import {
  Component,
  Input,
  ViewChild
} from '@angular/core';
import { CalendarInnerComponent } from './calendar-inner.component';

@Component({
  selector: 'axis-calendar-daybtn,[axis-calendar-daybtn]',
  template: `<button
  *ngIf="!(calendar.onlyCurrentMonth && calendarInnerRef.secondary)"
  class="axis-btn"
  (click)="calendarInnerRef.date ? calendar.select(calendarInnerRef.date) : ''"
  [ngClass]="{
    'btn-secondary': !calendarInnerRef.selected && !calendar.isActive(calendarInnerRef),
    'date-selected': calendarInnerRef.selected  || calendarInnerRef.startDate || calendarInnerRef.endDate,
    'date-disabled': calendarInnerRef.disabled,
    'date-focused': calendarInnerRef.focused,
    'date-selected2':calendar.isActive(calendarInnerRef)
      }"
  tabindex="-1"
  type="button"
  #btn
>
<span [ngClass]="{'date-today':  calendarInnerRef.current}">{{calendarInnerRef.label}}</span>
</button>`
})
export class AxisDayButtonCalendarComponent {
  @Input() calendarInnerRef: any;
  @ViewChild('btn') btn: any;
  public calendar: CalendarInnerComponent;

  public constructor(
    calendar: CalendarInnerComponent,
  ) {
    this.calendar = calendar;
  }
}
